export class Language {
    Name: string = null;
    Culture: string = null;
}

export const Languages: Language[] = [
    { Name: 'English', Culture: 'en' },
    { Name: 'Portuguese', Culture: 'pt' }
];



// WEBPACK FOOTER //
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/app/shared/entities/language.ts